// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"style_menu-item__EGK52","text":"style_text__2DmhU","price":"style_price__Wdbrr","allergens":"style_allergens__1KmGA"};